import type { ComponentPropsWithRef } from "react";
import Status from "../UI/Status";
import type { Color } from "../UI/Text";

interface ProfileBadgeProps
  extends Omit<ComponentPropsWithRef<"span">, "color"> {
  variant?: Color;
}

export default function ProfileBadge({
  children,
  variant = "info",
  className,
  ...rest
}: ProfileBadgeProps) {
  return (
    <Status
      as="span"
      color={variant}
      text={children}
      className={className}
      {...rest}
    />
  );
}
